import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ROLE } from '../enums';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
	providedIn: 'root'
})
export class AdministratorGuard {
	private _authenticationService = inject(AuthenticationService);

	canActivate(_route: ActivatedRouteSnapshot): boolean {
		const currentUser = this._authenticationService.currentUser;
		if (currentUser) {
			return (
				this._authenticationService.selectedRole === ROLE.ADMINISTRATOR ||
				this._authenticationService.selectedRole === ROLE.SUPERADMIN
			);
		}
		return false;
	}
}
